import { Box, Tooltip, Typography, styled } from '@mui/material';
import { Plus } from '@styled-icons/bootstrap/Plus';
import { ReactComponent as DocumentImage } from 'assets/img/icons/document.svg';
import { ItemCardSmall, ThemeButton, ThemeTypography } from 'DesignSystem';
import truncate from 'lodash/truncate';
import React, { FC } from 'react';
import { EDocumentStatus, TDocumentStatus } from 'FeatureModules/Document/types/document.types';
import { IBaseDocument } from 'FeatureModules/Document/types/document.types';
import PageSubTitle from 'Components/PageSubTitle';

const Status = styled(Typography)<{ status: TDocumentStatus }>(({ status, theme }) => ({
  fontSize: 13,
  marginRight: 8,
  color: status === 'VALID' ? theme.palette.success.main : theme.palette.error.main,
}));

const DocumentIcon = styled(DocumentImage)(() => ({
  width: 26,
}));

const DocumentButton = styled(ThemeButton)(() => ({
  background: 'transparent',
}));

interface IPartnerDocumentListProps {
  title?: string;
  totalItems?: number;
  documents: IBaseDocument[];
  actionButtonText?: string;
  onCreateClick: () => void;
  onAllDocumentsClick: () => void;
}

const PartnerDocumentList: FC<IPartnerDocumentListProps> = ({
  title = 'Documents',
  documents,
  totalItems,
  actionButtonText = 'New request',
  onCreateClick,
  onAllDocumentsClick,
}) => {
  return (
    <Box flex={1} data-testid="document-list">
      <PageSubTitle title={title} visibleItems={documents.length} totalItems={totalItems} mb={2}>
        <Box display="flex" alignItems="center" gap={1}>
          {totalItems && documents.length < totalItems && (
            <DocumentButton
              onClick={onAllDocumentsClick}
              size="small"
              color="BLUE_ICE"
              data-testid="see-all-documents-btn"
            >
              See all documents
            </DocumentButton>
          )}
          <ThemeButton
            onClick={onCreateClick}
            startIcon={<Plus size={16} color="white" />}
            size="small"
            color="WHITE"
            data-testid="new-request-btn"
          >
            {actionButtonText}
          </ThemeButton>
        </Box>
      </PageSubTitle>

      <Box data-testid="home-document-container">
        {documents.map(document => (
          <ItemCardSmall key={document.id} onClickOpen={() => window.open(document.url, '_blank')}>
            <Box display="flex" alignItems="center" gap={2.5}>
              <Box pl={1}>
                <DocumentIcon />
              </Box>
              <Box>
                <Tooltip title={document.title || ''}>
                  <ThemeTypography variant="ITEM_TITLE">
                    {truncate(document.title, {
                      length: 45,
                      separator: '',
                    })}
                  </ThemeTypography>
                </Tooltip>
                <Box display="flex" alignItems="center" gap={0.8}>
                  <Status variant="body2" status={document.status}>
                    {EDocumentStatus[document.status]}
                  </Status>
                </Box>
              </Box>
            </Box>
          </ItemCardSmall>
        ))}
      </Box>
    </Box>
  );
};

export default PartnerDocumentList;
